<!-- 仓库主数据 -->
<template>
  <div class="store">
    <sirui-search
      ref="storeDataSearch"
      :query="query"
      :columns="searchFormColumns"
      labelWidth="125px"
      :defaultRow="2"
      @changeCompanyHandler="changeCompanyHandler"
      @changeDepartmentHandler="changeDepartmentHandler"
      @changeSupplyChainMethod="changeSupplyChainMethod"
      @changeProductTypeHandler="changeProductTypeHandler"
      @changeServiceTypeHandler="changeServiceTypeHandler"
      @resetBtnClick="resetBtnClickHandler"
      @searchBtnClick="queryBtnClickHandler"
    ></sirui-search>
    <div class="main-content">
      <sirui-table
        ref="siruiTable"
        :buttonList="menuButtonList"
        :showFooter="true"
        :footerMethod="footerMethod"
        :loading="loading"
        :data="tableData"
        :paging="true"
        :setting="false"
        :customVisible="true"
        :columns="columnList"
        @chooseClick="chooseClick"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
        @handleSelectionChange="handleSelectionChange"
        @dblclickEvent="ExpenseListDetail"
      >
        <vxe-table-column type="seq" width="50" title="序号"></vxe-table-column>
        <vxe-table-column
          v-for="(item, index) in columnList"
          :key="index"
          :fixed="item.fixed"
          :sortable="item.sortable"
          :field="item.field"
          :title="item.title ? $t(item.title) : null"
          :visible="item.visible"
          :type="item.type"
          :width="item.width"
        >
          <template v-slot="{ row }">
            <!-- <template v-if="item.field === 'unit'">{{
              basic_unit?.find((item) => item.value == row['unit'])?.label
            }}</template> -->
            <!-- <template v-else-if="item.field === 'productType'">{{
              productList?.find((item) => item.value == row['productType'])?.label
            }}</template>
            <template v-else-if="item.field === 'serviceType'">{{
              serviceAllList?.find((item) => item.value == row['serviceType'])?.label
            }}</template> -->
            <template v-if="item.field === 'processStatus'">{{
              row.processStatus == '0' ? '未处理' : '已处理'
            }}</template>
            <template v-else-if="item.field === 'multiBillingRuleFlag'">{{
              row.multiBillingRuleFlag == '0' ? '否' : '是'
            }}</template>
            <template v-else-if="item.field === 'confirmStatus'">{{
              ['01'].includes(row.confirmStatus) ? '待确认' : '已确认'
            }}</template>
            <template v-else-if="item.field === 'abnormalExpenseFlag'">{{
              [0].includes(row.abnormalExpenseFlag) ? '否' : '是'
            }}</template>
            <template v-else-if="item.field === 'expenseNo'">
              <div>{{ row[item.field] }}</div>
            </template>
            <template v-else-if="item.field === 'createMethod'">{{
              row.createMethod == '01' ? '系统' : '手动'
            }}</template>
            <template v-else>{{ row[item.field] }}</template>
          </template>
        </vxe-table-column>
      </sirui-table>
    </div>
    <SelectInstructionListDialog
      ref="SelectInstructionListDialog"
      @SelectInstructionHandler="SelectInstructionHandler"
    ></SelectInstructionListDialog>
    <AddExpenseDialog ref="AddExpenseDialog" @AddExpenseHandler="getTableData"></AddExpenseDialog>
  </div>
</template>

<script>
  import SiruiSearch from '@/components/SiruiSearch';
  import SiruiTable from '@/components/SiruiTable';
  // import API from '@/api/storeMasterData';
  import { searchColumns, defaultTableColumn, defaultMenuBtnList } from './index.js';
  // import tradeMixin from './../../mixin/tradeMixin';
  import RECEIVABLES_TRADE from '@/api/receivablesAndPayables/trade.js';
  import RECEIVABLES_MULTIMODALTRANSPORT from '@/api/receivablesAndPayables/multimodalTransport.js';
  import expenseListMixin from './index.js';
  import SelectInstructionListDialog from './components/SelectInstructionListDialog/index.vue';
  import AddExpenseDialog from './components/AddExpenseDialog/index.vue';
  export default {
    mixins: [expenseListMixin],
    name: 'Trade',
    components: {
      SiruiSearch,
      SiruiTable,
      SelectInstructionListDialog,
      AddExpenseDialog,
    },
    computed: {
      searchFormColumns() {
        return searchColumns(this);
      },
      expenseType() {
        return this.dictListMap.expenseType;
      },
      basic_unit() {
        return this.dictListMap.basic_unit;
      },
      // 公路服务
      highwayList() {
        return this.serviceList.slice(0, 6);
      },
      railwayList() {
        return this.serviceList.slice(6);
      },
    },
    mounted() {
      // this.getTableData();
      this.getButtonList();
    },
    data() {
      return {
        loading: false,
        handleRejectValue: '',
        menuButtonList: [], // 表格功能按钮
        multipleSelection: [], // 表格被选中的行数据
        tableData: [], // 表格数据
        importUrl: '',
        importData: {},
        columnList: [],
        // query: {
        //   pageNum: 1,
        //   pageSize: 10,
        //   expenseNo: '',
        //   businessCompanyNo: '',
        //   businessDepartmentCode: '',
        //   processStatus: null,
        //   expenseTypeList: [],
        //   businessDocCodeLike: '',
        //   productType: '',
        //   serviceType: '',
        //   businessCategory: '02',
        //   accountPeriod: '',
        //   expenseGenerationDateStart: '',
        //   expenseGenerationDateEnd: '',
        //   abnormalExpenseFlag: '',
        //   confirmStatus: '',
        //   customerNo: '',
        //   contractNo: '',
        //   createMethod: '',
        //   originalAmountStart: '',
        //   originalAmountEnd: '',
        //   salesmanNo: '',
        // },
      };
    },
    methods: {
      SelectInstructionHandler(val) {
        console.log(val, '选择-------------》');
        this.$refs.AddExpenseDialog.selectInstructionDetailList = val;
        setTimeout(() => {
          this.$refs.AddExpenseDialog.openDialog();
        }, 100);
      },
      AddExpenseHandler(val) {
        console.log(val);
      },
      footerMethod({ columns }) {
        return [
          columns.map((column, columnIndex) => {
            if (columnIndex === 0) {
              return '合计';
            }
            if (columnIndex === 3) {
              return `原币结算金额（含税） `;
            } else if (columnIndex === 5) {
              return `本币结算金额（含税）`;
            }
            return null;
          }),
        ];
      },
      // 计算选中金额
      _computedAmount(selection) {
        console.log(selection);
        const originalAmount = selection.reduce((prev, cur) => prev + +cur.originalAmount, 0);
        const domesticAmount = selection.reduce((prev, cur) => prev + +cur.domesticAmount, 0);
        const allTdDom = document.querySelector('.vxe-footer--row').querySelectorAll('td');
        const totalDom1 = allTdDom[4];
        const totalDom2 = allTdDom[6];
        totalDom1.querySelector('.vxe-cell').innerHTML = this.$utils.commafy(
          this.$utils.toNumber(Math.round(originalAmount * 100) / 100),
          { digits: 2 }
        );
        totalDom2.querySelector('.vxe-cell').innerHTML = this.$utils.commafy(
          this.$utils.toNumber(Math.round(domesticAmount * 100) / 100),
          { digits: 2 }
        );
        // totalDom1.querySelector('.vxe-cell').innerHTML = originalAmount.toFixed(2);
        // totalDom2.querySelector('.vxe-cell').innerHTML = domesticAmount.toFixed(2);
      },
      ExpenseListDetail({ row }) {
        console.log(row, '费用清单详情');
        let { id, serviceType, confirmStatus, abnormalExpenseFlag } = row;
        let path = {
          path: '/receivablesAndPayables/multimodalTransportExpenseListYSDetail',
          name: 'multimodalTransportExpenseListYSDetail',
          meta: {
            keepAlive: true,
            title: '应收费用详情',
          },
          query: { id, serviceType, confirmStatus, abnormalExpenseFlag },
        };
        this.$store.dispatch('tagsView/addTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path);
          });
        });
      },

      // 切换供应商
      changeSupplyChainMethod(val) {
        console.log(val, '修改客户');
        const rowData = val[0];
        this.query = {
          ...this.query,
          customerNo: rowData?.partnerCode,
        };
      },
      // 修改合同
      changeContractMethod(val) {
        this.query.contractNo = val[0].contractCode;
        console.log(val, '修改合同');
      },
      // 修改投送人
      changeDelivererNameMethod(val) {
        console.log(val, '修改同送人');
        this.query.delivererNo = val[0]?.personNo || '';
      },
      // 修改业务员
      changeSalesmanNoMethod(val) {
        this.query.salesmanNo = val[0]?.id || '';
      },
      //获取菜单按钮
      getButtonList() {
        this.getButtons().then((e) => {
          console.log(e, '应收查看按钮列表');
          // this.menuButtonList = e;
          this.menuButtonList = defaultMenuBtnList;
          this.getColumnInfo();
        });
      },
      //获取当前列
      getColumnInfo() {
        this.getColumnList(defaultTableColumn(this)).then(() => {
          // console.log(11111);
          this.columnList = defaultTableColumn(this);
        });
      },
      // 获取表格数据
      async getTableData(search) {
        console.log(search, '搜索');
        // this.tableData = this.mockDataList;
        this.loading = true;
        const postData = {
          ...this.query,
          processStatus: this.query.processStatus == null ? null : +this.query.processStatus,
          pageNum: this.$refs.siruiTable.page.pageNum,
          pageSize: this.$refs.siruiTable.page.pageSize,
          businessGroup: this.userInfo.businessGroup,
        };
        const { data } = await this.$axios.post(
          RECEIVABLES_TRADE.RECEIVABLESEXPENSE_QUERY,
          postData
        );
        console.log(data, '应收费用清单');
        this.loading = false;
        this.tableData = data.data?.records;
        // this.tableData.forEach((item) => {
        //   item.domesticAmount = item.domesticAmount.toFixed(2);
        //   item.originalAmount = item.originalAmount.toFixed(2);
        // });
        this.$refs.siruiTable.setPageTotal(data.data?.total);
      },
      // 表格上面的按钮
      async chooseClick(type) {
        console.log(type, '点击按钮操作');
        if (type == 'create') {
          // TODO 判断必须要选择行才可以跳转
          const selectedList = this.multipleSelection;
          if (!selectedList.length) {
            this.$message.error('请选择行操作');
            return;
          }
          let processStatusList = selectedList.filter((item) => item.processStatus == 1);
          let confirmStatusList = selectedList.filter((item) =>
            ['01'].includes(item.confirmStatus)
          );
          console.log(processStatusList, 'processStatusList');
          if (processStatusList.length > 0) {
            this.$message.error('已处理的费用清单不能再次创建');
            return;
          }
          if (confirmStatusList.length > 0) {
            this.$message.error('待确认状态的费用单不可生成对账单，需要先进行草稿确认');
            return;
          }
          let orderCodeList = [];
          let orderCodeStatus = null;
          let contractNoList = [];
          let contractNoStatus = null;
          let ids = [];
          selectedList.map((item) => {
            orderCodeList.push(item.orderCode);
            contractNoList.push(item.contractNo);
            ids.push(+item.id);
          });
          // console.log(ids, 'idssssssssssss');
          orderCodeStatus = this.isAllEqual(orderCodeList);
          contractNoStatus = this.isAllEqual(contractNoList);
          // console.log(productNameList, 'productNameList');
          // console.log(productNameStatus, 'productNameStatus');
          // console.log(contractNoList, 'contractNoList');
          // console.log(contractNoStatus, 'contractNoStatus');

          if (!orderCodeStatus || !contractNoStatus) {
            this.$message.error('所选内容的合同或订单编号不一致');
            return;
          }

          let path = {
            path: '/receivablesAndPayables/multimodalTransportReceivablesDetail',
            name: 'multimodalTransportReceivablesDetail',
            meta: {
              keepAlive: true,
              title: '创建应收结算',
            },
            query: {
              status: 'create',
              id: ids,
            },
          };
          this.$store.dispatch('tagsView/addTabView', path).then(() => {
            this.$nextTick(() => {
              this.$router.push(path);
            });
          });
        } else if (type == 'export') {
          const selectedList = this.multipleSelection;
          if (selectedList.length > 0) {
            const postData = [];
            selectedList.map((item) => {
              postData.push(item.id);
            });
            const { data } = await this.$axios.post(RECEIVABLES_TRADE.RECEIVABLESEXPENSE_EXPORT, {
              ids: postData,
              businessCategory: this.query?.businessCategory,
            });
            if (data.code === 0) {
              window.location.href = data.data;
              this.$message.success('导出成功');
            } else {
              this.$message.error('导出失败');
            }
          } else {
            const postData = this.query;
            const { data } = await this.$axios.post(
              RECEIVABLES_TRADE.RECEIVABLESEXPENSE_EXPORT,
              postData
            );
            if (data.code === 0) {
              window.location.href = data.data;
              this.$message.success('导出成功');
            } else {
              this.$message.error('导出失败');
            }
          }
        } else if (type == 'add') {
          console.log('费用补录');
          this.$refs.SelectInstructionListDialog.openDialog();
        } else if (type == 'delete') {
          console.log('删除');
          let selectedList = this.multipleSelection;
          if (!selectedList.length) {
            this.$message.error('请选择行操作');
            return;
          }
          let processStatusList = selectedList.filter((item) => [1].includes(item.processStatus));
          if (processStatusList.length > 0) {
            this.$message.error('所选择的数据包含不可删除的数据，请确认');
            return;
          }
          this.$confirm('确定要删除吗？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          })
            .then(async () => {
              const postData = [];
              selectedList.map((item) => {
                postData.push(+item.id);
              });
              const { data } = await this.$axios.post(
                RECEIVABLES_MULTIMODALTRANSPORT.RECEIVABLESEXPENSE_DELETE_API,
                {
                  ids: postData,
                  // oaId: this.userInfo.userInfo.oaId,
                }
              );
              if (data.code === 0) {
                this.$message.success('删除成功');
                this.queryBtnClickHandler();
              } else {
                this.$message.error(`${data.msg}`);
              }
            })
            .catch(() => {});
        } else if (type == 'enable') {
          console.log('草稿确认');
          let selectedList = this.multipleSelection;
          if (!selectedList.length) {
            this.$message.error('请选择行操作');
            return;
          }
          let confirmStatusList = selectedList.filter((item) =>
            ['02'].includes(item.confirmStatus)
          );
          if (confirmStatusList.length) {
            this.$message.error('所选数据中包含了已确认的数据，请重选');
            return;
          }
          this.$confirm('是否确认已核对费用？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          })
            .then(async () => {
              const postData = [];
              selectedList.map((item) => {
                postData.push(+item.id);
              });
              const { data } = await this.$axios.post(
                RECEIVABLES_MULTIMODALTRANSPORT.RECEIVABLESEXPENSE_ENABLE_API,
                {
                  ids: postData,
                  // oaId: this.userInfo.userInfo.oaId,
                }
              );
              if (data.code === 0) {
                this.$message.success('确认成功');
                this.queryBtnClickHandler();
              } else {
                this.$message.error(`${data.msg}`);
              }
            })
            .catch(() => {});
        } else if (type == 'reconciliationExport') {
          console.log('对账导出');
          const selectedList = this.multipleSelection;
          if (selectedList.length > 0) {
            const postData = [];
            selectedList.map((item) => {
              postData.push(item.id);
            });
            const { data } = await this.$axios.post(RECEIVABLES_TRADE.EXPORT_OILCARD, {
              ids: postData,
            });
            if (data.code === 0) {
              window.location.href = data.data;
              this.$message.success('导出成功');
            } else {
              this.$message.error('导出失败');
            }
          } else {
            const postData = this.query;
            const { data } = await this.$axios.post(RECEIVABLES_TRADE.EXPORT_OILCARD, postData);
            if (data.code === 0) {
              window.location.href = data.data;
              this.$message.success('导出成功');
            } else {
              this.$message.error('导出失败');
            }
          }
        }
      },
      //判断数组里元素是否全相等
      isAllEqual(array) {
        if (array.length > 0) {
          return !array.some(function (value) {
            return value !== array[0];
          });
        } else {
          return true;
        }
      },

      // 表格选择行
      handleSelectionChange(row) {
        console.log(row);
        this.multipleSelection = row;
        this._computedAmount(row);
      },
      // 搜索
      queryBtnClickHandler() {
        console.log('搜索', this.query);
        console.log(this.userInfo?.departmentCode, '搜索this.userInfo?.departmentCode');
        this.$refs.siruiTable.setPageNum(1);
        this.$refs.siruiTable.clearCheckboxReserve();
        this._computedAmount([]);
        this.getTableData();
      },
      // 重置
      resetBtnClickHandler() {
        console.log(this.userInfo?.departmentCode, '重置this.userInfo?.departmentCode');
        this.$refs.siruiTable.setPageNum(1);
        this.$refs.siruiTable.setPageSize(10);
        this.$refs.siruiTable.clearCheckboxReserve();
        this._computedAmount([]);
        if (this.userInfo.companyCode != 'OAC19') {
          this.query = {
            ...this.query,
            businessCompanyNo: this.userInfo.companyCode,
            // settlementDepartmentNo: this.userInfo?.departmentCode,
          };
          this._getDepartmentByCompanyCodeApi(this.userInfo.companyCode);
        }
        // this.query = {
        //   ...this.query,
        //   businessCompanyNo: this.userInfo.companyCode,
        //   // businessDepartmentCode: this.userInfo?.departmentCode,
        // };
        // this.businessCompanyName = this.userInfo.companyName;
        this.expenseTypeList = [];
        this.serviceList = [];
        this.getTableData();
      },
      // 修改每页条数
      handleSizeChange() {
        this.$refs.siruiTable.setPageNum(1);
        this.getTableData();
      },
      // 修改当前页
      handleCurrentChange() {
        this.getTableData();
      },
    },
  };
</script>

<style lang="scss" scoped></style>
